import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function OnlineBanner() {
  const online = useOnlineStatus();
  const { t } = useTranslation();

  if (online) return null;

  return (
    <div
      role="alert"
      className="flex items-center gap-3 border-b px-4 py-3 text-sm"
      style={{
        background: 'var(--fv-online-banner)',
        color: 'var(--fv-online-banner-text)',
        borderColor: 'var(--fv-warning)'
      }}
    >
      <WifiOff className="h-5 w-5 shrink-0" aria-hidden />
      <div>
        <p className="font-semibold">{t('online.offlineTitle')}</p>
        <p className="mt-0.5 opacity-90">{t('online.offlineBody')}</p>
      </div>
    </div>
  );
}
